import PropTypes from 'prop-types';
import React from 'react';
import * as ReactDOM from 'react-dom';

class ModalToBody extends React.Component {
  static propTypes = {
    children: PropTypes.array,
    render: PropTypes.bool,
  };

  render() {
    if (this.props.render === true || this.props.render === undefined) {
      return ReactDOM.createPortal(this.props.children, document.getElementById('portal'));
    } else {
      return null;
    }
  }
}

export default ModalToBody;
